var _dec, _dec2, _class, _descriptor, _descriptor2, _dec3, _dec4, _dec5, _dec6, _dec7, _class2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import anyTrait from "../Decorators/anyTrait";
import objectArrayTrait from "../Decorators/objectArrayTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import ModelTraits from "../ModelTraits";
import UrlTraits from "./UrlTraits";
export let QueryParamTraits = (_dec = primitiveTrait({
  name: "Parameter name",
  type: "string",
  description: "The name of the query parameter."
}), _dec2 = primitiveTrait({
  name: "Parameter value",
  type: "string",
  description: "The value of the query parameter. Parameter values starting with" + " `DATE!`, eg. `DATE!HH:MM`, will be replaced wih the current date and" + " time, formatted according to the format string following the `!`." + " For more information on the format string format, see the " + " [dateformat](https://github.com/felixge/node-dateformat) library."
}), _class = class QueryParamTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "value", _descriptor2, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "value", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

/** Not all traits here will be supported by all catalog items that use them */
let ApiRequestTraits = (_dec3 = objectArrayTrait({
  name: "Query parameters",
  type: QueryParamTraits,
  description: "Query parameters to supply to the API",
  idProperty: "name"
}), _dec4 = objectArrayTrait({
  name: "Query parameters for updates",
  type: QueryParamTraits,
  description: "Query parameters to supply to the API on subsequent calls after the first call.",
  idProperty: "name"
}), _dec5 = anyTrait({
  name: "Request body",
  description: "JSON body to be sent with the HTTP request to the server. If provided, the request will be made as POST rather than a GET."
}), _dec6 = primitiveTrait({
  name: "POST as form data",
  type: "boolean",
  description: "Send the request data as form data instead of a JSON body."
}), _dec7 = primitiveTrait({
  name: "Response data path",
  type: "string",
  description: "Path to relevant data in JSON response. eg: `some.user.name`, `some.users[0].name` or `some.users[].name`"
}), _class2 = class ApiRequestTraits extends mixTraits(UrlTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "queryParameters", _descriptor3, this);
    _initializerDefineProperty(this, "updateQueryParameters", _descriptor4, this);
    _initializerDefineProperty(this, "requestData", _descriptor5, this);
    _initializerDefineProperty(this, "postRequestDataAsFormData", _descriptor6, this);
    _initializerDefineProperty(this, "responseDataPath", _descriptor7, this);
  }
}, _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "queryParameters", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "updateQueryParameters", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "requestData", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "postRequestDataAsFormData", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "responseDataPath", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
export { ApiRequestTraits as default };